module.exports = __webpack_public_path__ + "img/set_theme_10.74efadb6.png";